// LEGACY: Uses SCSS with CSS modules. New code should use @metarouter-private/mr-mui components instead.
// LEGACY: Uses @ion/components. New code should use @metarouter-private/mr-mui components instead.
import React from 'react';
import cx from 'classnames';
import pt from 'prop-types';
import { alphabetizeBy } from '@ion/mrdash';

import { MrLink, MrModal } from '@ion/components';
import { Typography } from '@metarouter-private/mr-mui';
import { useQueryUserOrganizations } from '@ion/api';
import { useSwitchOrg } from '@ion/api';
import useAfterOrgSwitch from 'app/after-org-switch';

import OrgAvatar from 'app/components/org-avatar';

import s from './index.module.scss';
import { useUserContext } from '@ion/user';

export function alphabetizeOrgs(orgs) {
  return alphabetizeBy(orgs, 'display_name');
}

const OrgSwitcher = ({ orgId, closeModal }) => {
  const afterOrgSwitch = useAfterOrgSwitch();
  const { currentOrg } = useUserContext();
  const { data: orgs } = useQueryUserOrganizations();
  const displayOrgs = orgs.length === 0 ? [currentOrg] : orgs;

  const [switchOrg] = useSwitchOrg({
    onCompleted: data => {
      const newOrgId = data.auth0_user_switch_orgs.orgId;
      afterOrgSwitch({ orgId: newOrgId });
    },
  });

  return (
    <MrModal closeModal={closeModal} styleNames="basic allowOverflow">
      <div className={s.header}>
        <Typography variant="h4">Switch Organizations</Typography>
      </div>
      <div className={s.content}>
        {alphabetizeOrgs(displayOrgs).map(org => (
          <MrLink
            key={org.id}
            className={cx(s.org, orgId === org.id && s.selected)}
            onClick={() => {
              switchOrg({ orgId: org.id });
            }}
          >
            <OrgAvatar org={org} />
          </MrLink>
        ))}
      </div>
    </MrModal>
  );
};

OrgSwitcher.propTypes = {
  orgId: pt.string,
  closeModal: pt.func,
  className: pt.string,
};

export default OrgSwitcher;
